<template>
  <footer>
    <div class="">
      <div class="astro-wrapper">
        <img src="../assets/images/xrp-astronout-on-planet.png">
      </div>
      <div class="terms-wrapper">
        <a :href="`${baseUrl}terms`" style="margin-top: 30px; color: white;">Terms and Conditions</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MainFooter',
  data(){
    return {
      baseUrl: process.env.VUE_APP_PUBLIC_PATH
    }
  }
}

</script>

<style scoped>
footer {
    width: 100%;
    min-height: 300px;
    background: inherit;
    margin: auto;
}

.astro-wrapper,
.terms-wrapper {
    display: flex;
    justify-content: center;
    align-content: center;
    margin: auto;
    margin-top: 50px;
}

.astro-wrapper img {
    width: min(300px, 50%);
}

.terms-wrapper {
    padding-bottom: 100px;
}

.terms-wrapper a {
    text-decoration: none;
}

</style>
